import React from 'react';

const PublicRouter = ({children, template: Template, title: Title, ...rest}) => {
    document.title = Title;
    return (
        <Template {...rest}>
            {children}
        </Template>
    );
}
export default PublicRouter;
